import { render, staticRenderFns } from "./ConsultButton.vue?vue&type=template&id=a0259b94&scoped=true"
import script from "./ConsultButton.vue?vue&type=script&lang=js"
export * from "./ConsultButton.vue?vue&type=script&lang=js"
import style0 from "./ConsultButton.vue?vue&type=style&index=0&id=a0259b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0259b94",
  null
  
)

export default component.exports